export const UrlAppPrefix = "/loyalty/";
export const UrlPathMain = (window.env.PUBLIC_URL || process.env.PUBLIC_URL) + UrlAppPrefix;

export const TabCircle = "circle";
export const TabFlow = "flow";
export const TabCardDesign = "card-designs";
export const TabDSGVO = "dsgvo";
export const TabFilter = "receiptdetail";
export const TabCustomField = "customfield";

export const TabLinks = "links";
export const TabCarousel = "carousels";
export const TabSplash = "splash";

export const UrlPathReports = UrlPathMain + "report";
export const UrlPathPreferences = UrlPathMain + "preferences";
export const UrlPathPreferencesCreate = UrlPathPreferences + "/create";
export const UrlPathPreferencesEdit = UrlPathPreferences + "/:id/edit";
export const UrlPathBonus = UrlPathMain + "bonus";
export const UrlPathBonusCreate = UrlPathBonus + "/create";
export const UrlPathBonusViewMode = UrlPathBonus + "/:id/:viewMode/";
export const UrlPathReceiptScanning = UrlPathMain + "receipts";
export const UrlPathReceiptScanningDetail = UrlPathReceiptScanning + "/:id/:viewMode/";
export const UrlPathBonusXpress = UrlPathMain + "bonusxpress";
export const UrlPathAppContent = UrlPathMain + "appcontent";
export const UrlPathAppContentLinks = UrlPathAppContent + "/" + TabLinks;
export const UrlPathAppContentCarousel = UrlPathAppContent + "/" + TabCarousel;
export const UrlPathAppContentSplash = UrlPathAppContent + "/" + TabSplash;
export const UrlPathCustomerSearch = UrlPathMain + "customer";
export const UrlPathCustomer = UrlPathMain + "customer";
export const UrlPathCustomerEdit = UrlPathCustomer + "/:id/edit";
export const UrlPathCustomerDetails = UrlPathCustomer + "/:id/details";
export const UrlPathCustomerPreferences = UrlPathCustomer + "/:id/preferences";
export const UrlPathCashback = UrlPathMain + "cashback";
export const UrlPathOperationalUnit = UrlPathMain + "operationalunit";
export const UrlPathOperationalUnitCreate = UrlPathOperationalUnit + "/create";
export const UrlPathAppContentCreate = UrlPathAppContentLinks + "/create";
export const UrlPathAppContentEdit = UrlPathAppContentLinks + "/:id/edit";
export const UrlPathCarouselCreate = UrlPathAppContentCarousel + "/create";
export const UrlPathCarouselEdit = UrlPathAppContentCarousel + "/:id/edit";
export const UrlPathOperationalUnitEdit = UrlPathOperationalUnit + "/:id/edit";
export const UrlPathUser = UrlPathMain + "user";
export const UrlPathUserCreate = UrlPathUser + "/create";
export const UrlPathUserEdit = UrlPathUser + "/:id/edit";
export const UrlPathRegistration = UrlPathCustomer + "/register";
export const UrlPathFamily = UrlPathMain + "family/:id";
export const UrlPathSetup = UrlPathMain + "setup";
export const UrlPathCircle = UrlPathSetup + "/" + TabCircle;
export const UrlPathCircleCreate = UrlPathCircle + "/create";
export const UrlPathCircleEdit = UrlPathCircle + "/:id/edit";
export const UrlPathCardDesign = UrlPathSetup + "/" + TabCardDesign;
export const UrlPathCardDesignCreate = UrlPathCardDesign + "/create";
export const UrlPathCardDesignEdit = UrlPathCardDesign + "/:id/edit";
// Pass-era path kept so bookmarks of /setup/pass and its subpaths still resolve; App redirects them to UrlPathCardDesign.
export const UrlPathCardDesignLegacy = UrlPathSetup + "/pass";


export const UrlPathFlow = UrlPathMain + TabFlow;
export const UrlPathFlowCreate = UrlPathFlow + "/create";
export const UrlPathFlowEdit = UrlPathFlow + "/:id/edit";
export const UrlPathGdpr = UrlPathSetup + "/" + TabDSGVO;
export const UrlPathInteractionSearch = UrlPathMain + "interactionsearch";
export const UrlPathReceiptDetail = UrlPathSetup + "/" + TabFilter;
export const UrlPathCustomField = UrlPathSetup + "/" + TabCustomField;
export const UrlPathConfigValueCreate = (url: string) => url + "/create";
export const UrlPathConfigValueEdit = (url: string) => url + "/:id/edit";
export const URlPathLanding = UrlPathMain + "landing";
export const URlPathPkPassDownload = UrlPathMain + "passes/download";
// Card-era twin of the pass download page; identity-management emits /cards/download links since the card API.
export const URlPathCardDownload = UrlPathMain + "cards/download";
export const URlPathDownloadFile = UrlPathMain + "download-file";

export const UrlPathSegment = UrlPathMain + "segments";
export const UrlPathSegmentCreate = UrlPathSegment + "/create";
export const UrlPathSegmentDetail = UrlPathSegment + "/:id/:viewMode";
export const UrlPathSegmentBuilder = UrlPathSegment + "/builder";
export const UrlPathSegmentBuilderCsv = UrlPathSegmentBuilder + "/csv";
export const UrlPathSegmentBuilderAi = UrlPathSegmentBuilder + "/ai";
export const UrlPathSegmentBuilderEasy = UrlPathSegmentBuilder + "/easy";

export const UrlPathCoupon = UrlPathMain + "coupon";
export const UrlPathCouponCreate = UrlPathCoupon + "/create";
export const UrlPathCouponEdit = UrlPathCoupon + "/:id/edit";
export const UrlPathCouponAssign = UrlPathCoupon + "/:id/assign";

export const UrlPathCampaignExperimental = UrlPathMain + "campaigns";
export const UrlPathCampaignExperimentalCreate = UrlPathCampaignExperimental + "/create";
export const UrlPathCampaignExperimentalEdit = UrlPathCampaignExperimental + "/:campaignNumber/edit";

const publicPaths = [URlPathLanding, URlPathPkPassDownload, URlPathCardDownload];

export const isPublicPath = () => publicPaths.includes(window.location.pathname);
